// The attachment rule the browser enforces before the server does. The
// allowed types and the sentence come from ConversationComposer::MEDIA
// through data attributes, so this file spells no list of its own. The
// server's byte sniff (check_media) is the failsafe; this is the courtesy
// that refuses a file at drop time, by name, instead of at send time.
export const MEDIA_CAP = 1_000_000

export function screenFiles(files, types, sentence) {
  const ok = []
  const notes = []
  for (const f of Array.from(files)) {
    if (f.type !== "" && !types.includes(f.type)) notes.push(`${f.name} can't go by text. ${sentence}`)
    else if (f.size >= MEDIA_CAP) notes.push(`${f.name} is ${(f.size / 1_000_000).toFixed(1)} MB. A text carries under 1 MB together.`)
    else ok.push(f)
  }
  return { ok, note: notes.join(" ") }
}

export function pastedFiles(event) {
  return Array.from(event.clipboardData?.items || []).filter((i) => i.kind === "file").map((i) => i.getAsFile()).filter(Boolean)
}
